export default "__VITE_ASSET__D8Cme1V6__"